import styled from 'styled-components'
import { Button } from '@progress/kendo-react-buttons'
import { DateInput } from '@progress/kendo-react-dateinputs'

export const Page = styled.div`
    @media screen {
        margin-left: 160px;
        margin-right: 160px;
        margin-top: 50px;
        margin-bottom: 250px;
    }

    @media print {
        width: 25cm;
        height: 29.7cm;
        margin: 10mm 15mm 10mm 15mm; 
    }

    @page{
        size:  auto;   
        margin-top: 0mm;
        margin-bottom: 0mm;
    }
`

export const BackButton = styled(Button)`
    margin: 15px 0 0 15px;

    @media print {
        display: none;
    }

`

export const FieldDescription = styled.p`
    display: block;
    margin: 0px 0px 6px 5px;
    height: 16px;
`

export const Row = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: ${(props) => props.narrow ? '10px' : '15px'};
`

export const Column = styled.div`
    width: 49%;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
`

export const Section = styled.div`
    width: ${(props) => props.width};
    display: inline-block;

    font-weight: bold;
    font-size: 12pt;
`

export const HeaderRow = styled.div`
    display: flex;
    align-items: center;
    margin: 6px 0;
`

export const HeaderText = styled.span`
    min-width: 100px;
    font-weight: bold;
`

export const HeaderTextfield = styled.textarea`
    font-family: Arial, Helvetica, sans-serif;  
    font-size: 13pt;
    outline: 0px none transparent;
    background-color: rgb(245, 245, 245);
    border-radius: 0px;
    border: none transparent;

    width: 400px;
    resize: none;

    @media print {
        background-color: white;
    }
`

export const InputField = styled.textarea`
    font-family: Arial, Helvetica, sans-serif;
    font-size: 13pt;

    outline: 0px none transparent;
    background-color: rgb(235, 235, 235);
    border-radius: 0px;
    border: none transparent;

    padding: 7px 6px;
    resize: none;
    display: block;

    width: 100%;
`

export const ResizableInputField = styled(InputField)`
    resize: vertical;
`

export const DateInputField = styled(DateInput)`
    font-family: Arial, Helvetica, sans-serif;
    font-size: 13pt;

    outline: 0px none transparent;
    background-color: rgb(235, 235, 235);
    border-radius: 0px;
    border: none transparent;

    padding: 7px 6px;
    resize: none;
    display: block;

    width: 100%;
`

export const Invisible = styled.div`
    display: none;
`
export const PrintButtonContainer = styled.div`
    margin-top: 50px;
    display: flex;
    justify-content: center;
`

export const PrintButton = styled(Button)`
    font-size: 17px;
    background-color: rgb(0, 156, 127);
    box-shadow: 3px 3px 6px rgba(0, 156, 127, 0.4);
    color: white;
    border: none;
    padding: 8px 300px;
    @media print{
        display: none;
    }
`



// WEBPACK FOOTER //
// ./src/components/printForm/PrintFormComponents.js